import React, { useState } from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { X, Check, StickyNote } from 'lucide-react';
import { toast } from 'sonner';

const QUICK_NOTES = [
  'Sin hielo', 'Muy caliente', 'Templado', 'Para compartir',
  'Sin gluten', 'Sin lactosa', 'Sin salsa', 'Extra grande',
  'Para llevar', 'Sin azúcar', 'Con hielo', 'Bien frío'
];

const NoteModal = ({ item, onAddNote, onClose }) => {
  const [noteText, setNoteText] = useState('');
  if (!item) return null;
  const itemKey = item.cartId || item.id;

  const applyNote = (note) => {
    onAddNote(itemKey, note);
    onClose();
    toast.success(`Nota: ${note}`, { duration: 600 });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40" data-testid="note-modal">
      <div className="bg-white rounded-t-2xl sm:rounded-2xl w-full max-w-md shadow-2xl">
        <div className="px-5 py-4 border-b flex items-center justify-between">
          <div className="flex items-center gap-2">
            <StickyNote size={18} className="text-amber-500" />
            <h3 className="font-bold text-gray-900">Nota: {item.name}</h3>
          </div>
          <button onClick={onClose} className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
            <X size={18} />
          </button>
        </div>
        <div className="p-4">
          <div className="flex flex-wrap gap-2 mb-4">
            {QUICK_NOTES.map(note => (
              <button key={note} onClick={() => applyNote(note)}
                className="px-4 py-2.5 bg-gray-100 hover:bg-amber-50 hover:text-amber-700 rounded-xl text-sm font-medium transition-colors active:scale-95"
                data-testid={`quick-note-${note.toLowerCase().replace(/\s/g, '-')}`}>
                {note}
              </button>
            ))}
          </div>
          <div className="flex gap-2">
            <Input value={noteText} onChange={e => setNoteText(e.target.value)} placeholder="Nota personalizada..."
              className="flex-1 h-12 text-base rounded-xl" onKeyDown={e => {
                if (e.key === 'Enter' && noteText.trim()) applyNote(noteText.trim());
              }} />
            <Button onClick={() => { if (noteText.trim()) applyNote(noteText.trim()); }}
              disabled={!noteText.trim()} className="h-12 px-4 bg-amber-500 hover:bg-amber-600">
              <Check size={20} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoteModal;
